import { Outlet } from "react-router-dom";

export default function TierManagementOutlet() {
  return <Outlet />;
}
